import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'boldWord'})
export class BoldWordPipe implements PipeTransform {
  transform(content: string, word: string): string {
    return content.replace(new RegExp(word, 'g'), "<strong>" + word + "</strong>");
  }
}
